const QUERIES = {
  AVAILABILITYS_LIST: 'availabilitys-list',
  BOOKINGS_LIST: 'bookings-list',
  CARTS_LIST: 'carts-list',
  CATEGORYS_LIST: 'categorys-list',
  COUPONS_LIST: 'coupons-list',
  CUSTOMERS_LIST: 'customers-list',
  EMAIL_TEMPLATES_LIST: 'email-templates-list',
  INVOICES_LIST: 'invoices-list',
  LOCATIONS_LIST: 'locations-list',
  PROFILES_LIST: 'profiles-list',
  PROFILE: 'profile',
  SERVICES_LIST: 'services-list',
  SERVICE_LOCATIONS_LIST: 'service-locations-list',
  SETTINGS_LIST: 'settings-list',
  METADATA_LIST: 'metadata-list',
  TIMEZONE: 'timezone',
  TIMEZONE_LIST: 'timezone-list',
  USERS_LIST: 'staffs-list',
  LABELS_LIST: 'labels-list',
  TAXRATES_LIST: 'taxrates-list',
  NOTOFICATIONS_LIST: 'notifications-list',
  SUMMARY: 'summary',
}

export {QUERIES}
